import {
    GetSearchBasicInfoList,
    GetMixSearchGoodsList,
} from "@/pages/page1/api/modules/goods";
import {
    AddShopCart,
    AddCollection
} from "@/pages/page1/api/modules/shoppingCart";
import DialogLogin from "@/pages/page1/components/dialogLogin.vue";
import onlyMessage from '@/pages/publicUtils/resetMessage.js'
export default {
    metaInfo: {
        title: "商品分类 - 多比商城",
        meta: [{
            name: "keyWords",
            content: "多比网,多比电商平台",
        }],
    },
    name: "category",
    components: {
        DialogLogin,
    },
    data() {
        return {
            loading: true,
            // 空间
            spaceList: [],
            spaceMore: false,
            spaceContentHeight: 48,
            // 分类
            categoryList: [],
            cateMore: false,
            cateContentHeight: 48,
            // 品牌
            brandList: [],
            brandMore: false, //更多
            brandMulti: false, //多选
            brandContentHeight: 70,
            //风格
            styleList: [],
            styleMore: false, //更多
            styleMulti: false, //多选
            styleContentHeight: 48,
            // 属性
            proplist: [],
            showProplist: [], //展示的属性，注意要指针相同
            // 选中的请求参数
            query: {
                // 获取基本信息的参数
                spaceSerNo: "",
                categorySerNo: "",
                brandSerNos: "",
                styleSerNos: "",
                // 获取商品列表的参数
                searchKey: "",
                props: {},
                sortType: 0,
                minPrice: undefined,
                maxPrice: undefined,
                whole: [],
            },
            pageInfo: {
                pageNumber: 1,
                pageSize: 40,
                searchProperty: [],
                orderProperty: [],
            },
            // 商品列表
            dataGoodsList: [],
            total: 1,
        };
    },
    mounted() {
        let query = this.$route.query;
        Object.assign(this.query, query);
        // object类型的需要转换
        this.query.whole = query.whole ? query.whole.split(",") : [];
        this.query.props = query.props ? JSON.parse(query.props) : {};
        // console.log(this.query);
        this.pageInfo.pageNumber = this.$route.query.page || 1;
        this.pageInfo.pageNumber = parseInt(this.pageInfo.pageNumber);
        this.getSearchBasicInfo();
    },
    methods: {
        // 初始化
        getSearchBasicInfo() {
            let params = {
                spaceSerNo: this.query.spaceSerNo,
                categorySerNo: this.query.categorySerNo,
                brandSerNos: this.query.brandSerNos ?
                    this.query.brandSerNos.split(",") : [],
                styleSerNos: this.query.styleSerNos ?
                    this.query.styleSerNos.split(",") : [],
            };
            GetSearchBasicInfoList(params).then((res) => {
                // console.log("获取分类页属性", res);
                this.spaceList = res.data[0].spaceList;
                this.categoryList = res.data[0].categoryList;
                this.openCateMore()
                this.brandList = this.setCheckedFalse(res.data[0].brandList);
                this.styleList = this.setCheckedFalse(res.data[0].styleList);
                this.proplist = this.setPropItem(res.data[0].proplist);
                // 如果是品牌入口，初始化选中
                this.brandList.forEach((item) => {
                    params.brandSerNos.forEach((v) => {
                        if (item.serNo == v) {
                            item.checked = true;
                        }
                    });
                });
                // 风格，初始化选中
                this.styleList.forEach((item) => {
                    params.styleSerNos.forEach((v) => {
                        if (item.serNo == v) {
                            item.checked = true;
                        }
                    });
                });
                // 初始化选中属性
                this.proplist.forEach((item) => {
                    for (let keyName in this.query.props) {
                        if (keyName == item.fieldName) {
                            item.showAttr = false;
                            item.fieldList.forEach((v) => {
                                this.query.props[keyName].forEach((j) => {
                                    if (v.value == j) {
                                        v.checked = true;
                                    }
                                });
                            });
                        }
                    }
                });
                // 可展示属性
                this.showProplist = this.proplist.filter((v) => v.showAttr);
                // 更多按钮展示控制
                this.getHeightForMore("spaceContentRef", "spaceContentHeight", 48);
                this.getHeightForMore("cateContentRef", "cateContentHeight", 48);
                this.getHeightForMore("brandContentRef", "brandContentHeight", 70);
                this.getHeightForMore("styleContentRef", "styleContentHeight", 48);
                this.getPropsHeightForMore();

                this.getGoodsList();
            });
        },
        // 初始化选中的分类被遮挡问题解决
        openCateMore() {
            let i = this.categoryList.findIndex((v) => v.serNo == this.query.categorySerNo)
            if (i < 0) return
            this.$nextTick(() => {
                // console.log(this.$refs['cateItem' + i][0].offsetTop);
                if (this.$refs['cateItem' + i][0].offsetTop > 0) this.cateMore = true
            })
        },
        setCheckedFalse(arr) {
            arr.forEach((v) => {
                v.checked = false;
            });
            return arr;
        },
        setPropItem(arr) {
            arr.forEach((item) => {
                // 控制属性值数组 更多 多选 显示
                this.$set(item, "fieldList", []);
                this.$set(item, "attrMore", false);
                this.$set(item, "attrMulti", false);
                this.$set(item, "showAttr", true);
                this.$set(item, "attrContentHeight", 48);
                item.fieldValueOption.forEach((v) => {
                    item.fieldList.push({
                        value: v,
                        checked: false,
                    });
                });
            });
            return arr;
        },
        getPropsHeightForMore() {
            this.showProplist.forEach((item, index) => {
                this.getHeightForMore(
                    "attrContentRef" + index,
                    "attrContentHeight",
                    48,
                    item
                );
            });
        },
        getHeightForMore(ref, typeHeight, height, item) {
            this.$nextTick(() => {
                if (item) {
                    let ele = this.$refs[ref][0];
                    item[typeHeight] = ele.clientHeight || height;
                    // console.log(typeHeight, item[typeHeight]);
                    return;
                }
                let ele = this.$refs[ref];
                try {
                    this[typeHeight] = ele.clientHeight || height;
                } catch (error) {}
                // console.log(typeHeight, this[typeHeight]);
            });
        },
        getGoodsList() {
            let params = {
                spaceSerNo: this.query.spaceSerNo,
                categorySerNo: this.query.categorySerNo,
                brandSerNos: this.query.brandSerNos ?
                    this.query.brandSerNos.split(",") : [],
                styleSerNos: this.query.styleSerNos ?
                    this.query.styleSerNos.split(",") : [],
                props: this.query.props,
                sortType: this.query.sortType,
                minPrice: this.query.minPrice,
                maxPrice: this.query.maxPrice,
                searchKey: this.query.searchKey,
                canUseForWholeList: this.query.whole,
                pageInfo: this.pageInfo,
            };
            this.loading = true
            GetMixSearchGoodsList(params).then((res) => {
                // console.log("获取商品列表", res);
                this.dataGoodsList = res.data;
                this.total = res.count;
                this.loading = false
            }).catch(() => {
                this.loading = false;
                this.total = 0
            })
        },

        // 空间（单击）
        sureSpace(serNo) {
            this.query.spaceSerNo = serNo;
            this.reloadSearch();
        },
        // 分类（单击）
        sureCategory(serNo) {
            this.query.categorySerNo = serNo;
            this.query.props = undefined;
            this.reloadSearch();
        },

        // 品牌 风格 属性（单击）
        chooseItem(arr, item, isMulti, type) {
            // 多选
            if (isMulti) {
                item.checked = !item.checked;
            } else {
                // 单选 若是属性需要关闭其他项的已选未确认
                if (type === "attr") {
                    this.showProplist.forEach((v) => {
                        v.fieldList = this.setCheckedFalse(v.fieldList);
                    });
                } else {
                    arr = this.setCheckedFalse(arr);
                }
                item.checked = true; //再选中
                this.setSelectSerNos(type);
                this.reloadSearch();
            }
        },
        // （打开多选）
        openMulti(brand, style, item) {
            this.brandList = this.setCheckedFalse(this.brandList);
            this.brandMulti = brand; //品牌
            this.brandMore = brand;
            this.styleList = this.setCheckedFalse(this.styleList);
            this.styleMulti = style; //风格
            this.styleMore = style;
            this.showProplist.forEach((v) => {
                v.fieldList = this.setCheckedFalse(v.fieldList);
                v.attrMulti = false;
                v.attrMore = false;
                if (item && v.fieldName === item.fieldName) {
                    v.attrMulti = true;
                    v.attrMore = true;
                }
            });
        },
        // （多选确认按钮）
        confirmMulti(arr, type) {
            let resItem = arr.find((v) => v.checked);
            if (!resItem) {
                onlyMessage.warning("请至少选择一项");
                return;
            }
            this.setSelectSerNos(type);
            this.reloadSearch();
        },
        // （多选取消按钮）
        cancelMulti(arr, type, item) {
            arr = this.setCheckedFalse(arr);
            if (type === "brand") {
                this.brandMulti = false;
                this.brandMore = false;
            } else if (type === "style") {
                this.styleMulti = false;
                this.styleMore = false;
            } else {
                item.attrMulti = false;
                item.attrMore = false;
            }
        },
        // 选中的项赋值
        setSelectSerNos(type) {
            switch (type) {
                case "brand":
                    this.query.brandSerNos = this.selectBrandStr;
                    break;
                case "style":
                    this.query.styleSerNos = this.selectStyleStr;
                    break;
                case "attr":
                    this.query.props = this.selectPropsObj;
                    break;
                default:
                    break;
            }
        },

        // 取消select项选中
        cancelSelect(item) {
            switch (item.type) {
                case 0: // 空间
                    this.query.spaceSerNo = undefined;
                    break;
                case 1: // 品牌
                    this.brandList.forEach((v) => {
                        if (item.serNo == v.serNo) {
                            v.checked = false;
                        }
                    });
                    this.query.brandSerNos = this.selectBrandStr;
                    break;
                case 2: // 风格
                    this.styleList.forEach((v) => {
                        if (item.serNo == v.serNo) {
                            v.checked = false;
                        }
                    });
                    this.query.styleSerNos = this.selectStyleStr;
                    break;
                case 3: // 属性
                    this.proplist.forEach((propItem) => {
                        propItem.fieldList.forEach((v) => {
                            if (item.serNo == v.value) {
                                v.checked = false;
                            }
                        });
                    });
                    this.query.props = this.selectPropsObj;
                    break;
            }
            this.reloadSearch();
        },
        // 清空select选中
        clearSelect() {
            this.query.spaceSerNo = undefined;

            this.query.searchKey = undefined;

            this.brandList = this.setCheckedFalse(this.brandList);
            this.query.brandSerNos = undefined;

            this.styleList = this.setCheckedFalse(this.styleList);
            this.query.styleSerNos = undefined;

            this.proplist.forEach((item) => {
                item.fieldList = this.setCheckedFalse(item.fieldList);
            });
            this.query.props = {};
            this.reloadSearch();
        },

        // 排序类别
        changeOrder(num) {
            this.query.sortType = num;
            this.reloadSearch();
        },
        // 价格确认
        surePrice() {
            let actualMinPrice; //实际小的值
            if (this.query.minPrice > this.query.maxPrice) {
                actualMinPrice = this.query.maxPrice;
                this.query.maxPrice = this.query.minPrice;
                this.query.minPrice = actualMinPrice;
            }
            this.reloadSearch();
        },
        onKeyUp(e) {
            // 保留整数值
            let isNum = parseInt(e.target.value)
            // console.log(e.target.value, !/^\d+$/.test(e.target.value), isNum);
            // 如果不是数字
            if (!/^\d+$/.test(e.target.value)) {
                e.target.value = isNum || "";
            }
        },
        // 拎包值model绑定["0","1"]
        wholeChange(val) {
            this.reloadSearch();
        },
        // 分页
        handleCurrentChange(val) {
            this.pageInfo.pageNumber = val;
            this.reloadSearch(val);
        },
        prevPage() {
            this.pageInfo.pageNumber = parseInt(this.pageInfo.pageNumber);
            this.pageInfo.pageNumber -= 1;
            this.reloadSearch(this.pageInfo.pageNumber);
        },
        nextPage() {
            this.pageInfo.pageNumber = parseInt(this.pageInfo.pageNumber);
            this.pageInfo.pageNumber += 1;
            this.reloadSearch(this.pageInfo.pageNumber);
        },
        // 页面刷新
        reloadSearch(page) {
            let query = {
                ...this.query,
                page: page ? page : undefined,
            };
            // 优化地址栏参数展示
            for (const key in query) {
                // 分类 品牌 关键词优化
                if (query[key] === "") {
                    query[key] = undefined;
                }
            }
            query.whole = query.whole.length > 0 ? query.whole.join(",") : undefined;
            query.props = JSON.stringify(query.props);
            if (query.props === "{}") {
                query.props = undefined;
            }
            if (query.sortType === 0) {
                query.sortType = undefined;
            }
            // console.log(query);
            // return
            let newUrl = this.$router.resolve({
                path: "/category",
                query,
            });
            window.open(newUrl.href, "_self");
        },

        // 登录操作
        updateLogin(isLogin) {
            // console.log(isLogin);
            if (isLogin) {
                location.reload();
            }
        },
        addShoppingCart(v) {
            if (this.$cookies.isKey("ACCESS_TOKEN")) {
                let params = {
                    goodsMixId: v.id,
                    goodsMixCount: 1,
                    regionCode: localStorage.getItem("_regionCode"),
                };
                AddShopCart(params).then((res) => {
                    // console.log("加入购物车结果", res);
                    onlyMessage.success("加入成功");
                    this.$store.commit("SET_SHOPCARTNUM");
                });
            } else {
                this.$refs.diaLogin.elVisible = true;
            }
        },
        followGoods(v) {
            if (this.$cookies.isKey("ACCESS_TOKEN")) {
                AddCollection({
                    goodsMixId: v.id
                }).then((res) => {
                    // console.log("移入收藏", res);
                    onlyMessage.success("收藏成功");
                });
            } else {
                this.$refs.diaLogin.elVisible = true;
            }
        },
    },
    computed: {
        selectList() {
            let arr = [];
            // 选中的空间
            this.spaceList.forEach((v) => {
                if (v.serNo == this.query.spaceSerNo) {
                    arr.push({
                        key: "空间",
                        value: v.name,
                        serNo: v.serNo,
                        type: 0,
                    });
                }
            });
            // 选中的品牌
            if (!this.brandMulti) {
                this.brandList.forEach((v) => {
                    if (v.checked) {
                        arr.push({
                            key: "品牌",
                            value: v.name,
                            serNo: v.serNo,
                            type: 1,
                        });
                    }
                });
            }
            // 选中的风格
            if (!this.styleMulti) {
                this.styleList.forEach((v) => {
                    if (v.checked) {
                        arr.push({
                            key: "风格",
                            value: v.name,
                            serNo: v.serNo,
                            type: 2,
                        });
                    }
                });
            }
            // 加上选中的属性
            this.proplist.forEach((item) => {
                if (!item.attrMulti) {
                    item.fieldList.forEach((v) => {
                        if (v.checked) {
                            arr.push({
                                key: item.name,
                                value: v.value,
                                serNo: v.value,
                                type: 3,
                            });
                        }
                    });
                }
            });
            return arr;
        },
        // 选中的品牌
        selectBrandStr() {
            let arr = [];
            arr = this.brandList.filter((v) => v.checked);
            arr = arr.map((v) => v.serNo);
            return arr.join(",");
        },
        // 选中的风格
        selectStyleStr() {
            let arr = [];
            arr = this.styleList.filter((v) => v.checked);
            arr = arr.map((v) => v.serNo);
            return arr.join(",");
        },
        // 选中的属性
        selectPropsObj() {
            let obj = {};
            this.proplist.forEach((item) => {
                let haveCheckedArr = item.fieldList.filter((v) => v.checked);
                haveCheckedArr = haveCheckedArr.map((v) => v.value);
                if (haveCheckedArr.length > 0) {
                    obj[item.fieldName] = haveCheckedArr;
                }
            });
            // console.log(this.proplist);
            return obj;
        },
    },
};